import {useState} from "react"
import axios from "axios"

function Markets(){

 const [markets,setMarkets]=useState([])
 const [triangular,setTriangular]=useState(false)
 const [threshold,setThreshold]=useState(0.3)

 const toggle=(m)=>{

  if(markets.includes(m))
   setMarkets(markets.filter(x=>x!==m))
  else
   setMarkets([...markets,m])

 }

 const save=async()=>{

  await axios.post(
   `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/settings/markets`,
   {
    markets,
    triangular,
    threshold
   }
  )

 }

 return(

 <div style={{padding:"40px"}}>

 <h2>Select Crypto Markets</h2>

 <label>
 <input type="checkbox" onChange={()=>toggle("binance")}/>
 Binance
 </label>

 <br/>

 <label>
 <input type="checkbox" onChange={()=>toggle("kraken")}/>
 Kraken
 </label>

 <br/>

 <label>
 <input type="checkbox" onChange={()=>toggle("bybit")}/>
 Bybit
 </label>

 <br/><br/>

 <h3>Trading Options</h3>

 <label>

 <input
  type="checkbox"
  checked={triangular}
  onChange={()=>setTriangular(!triangular)}
 />

 Enable Triangular Arbitrage

 </label>

 <br/><br/>

 <label>

 Spread Threshold %

 </label>

 <br/>

 <input
  type="number"
  step="0.1"
  value={threshold}
  onChange={e=>setThreshold(e.target.value)}
 />

 <br/><br/>

 <button onClick={save}>
 Save Settings
 </button>

 </div>

 )

}

export default Markets
